export enum Routes {
  EDITOR = "/editor",
  PROJECTS = "/projects",
  WORKSPACES = "/",
  PROJECT = "/project",
}

export default Routes;
